import { RootState } from '../store'

export const getSaveState = (state: RootState) => state.saveState.isSaved
export const isDialogOpen = (state: RootState) => state.saveState.isDialogOpen
export const getDialogNavigationRoute = (state: RootState) => state.saveState.dialogNavigationRoute
